import { Button, Icon } from '@driftt/tide-core-legacy'
import './style.styl'

const AddButton = ({ addButtonLabel, className, type, onClick, isProcessing, disabled }) => (
  <Button className={className} type={type} size="medium" onClick={onClick} loading={isProcessing} disabled={disabled}>
    <Icon
      className="plus-icon"
      width={15}
      height={10}
      stroke
      name="plus"
    />
    {addButtonLabel}
  </Button>
)

export default AddButton


// WEBPACK FOOTER //
// ./src/scripts/components/Integration/components/AddButton/index.js